(function () {
    angular.module('pages.master', [
        //'foundation',
        //'mm.foundation',
        'app',
        'components.anchor',
        'components.sticky',
        'components.carousel',                
        'components.loader',
        'components.modalSlider',
        'components.navigation',
        'components.pagination',
        'components.query',
        'components.relatedContent',
        'components.tiles',
        'pages.home',
        'pages.scrolledContent',
        'pages.tabbedContent',
        'services.global',
        'utility',
        'ui.router'
    ])
        .config(config)
        .run(run)
        .controller('modalSetController', modalSetController);
    
    run.$inject = ['$rootScope', 'global', '$location', '$http', '$window', '$timeout', '$state', '$transitions', 'modalSliderService'];
    function run($rootScope, global, $location, $http, $window, $timeout, $state, $transitions, modalSliderService) {
        $rootScope.ready = true;

        $rootScope.toggleSearch = function () {
            $rootScope.searchOpen = !$rootScope.searchOpen;
        }
        var body = angular.element('body');
        var mobileToggle = angular.element('#mobile-toggle');
        var menuIcon = angular.element('button.menu-icon');
        body.css('border-right-width', $window.outerWidth - angular.element('body').width());
        $rootScope.toggleDropdown = function () {
            $rootScope.dropdownOpen = !$rootScope.dropdownOpen;
            var header = angular.element('.header');
            var dropdown = header.find('.dropdown');
            if ($rootScope.dropdownOpen) {
                var timeline = new TimelineLite()
                    .set(dropdown, { height: 'auto', 'max-height': 'calc(100vh - ' + header.height() + 'px)' })
                    .from(dropdown, .3, { height: 0 });
            }
            else {
                var timeline = new TimelineLite()
                    .to(dropdown, .3, { height: 0 })
                    .set(dropdown, { clearProps: 'all' });
            }
        }

        $timeout(function () {
            var datepickers = $('.datepickerfield');
            if (datepickers.datepicker) {
                datepickers.datepicker({
                    dateFormat: 'mm/dd/y',
                    onClose: function (date, instance) {
                        instance.input.valid();
                    }
                });
            }
        });

        //Forces components that bind to "params" to update when it's modified.
        $rootScope.params = {};
        $rootScope.$watch('params', function (newVal) {
            if (newVal) {
                $rootScope.params = angular.copy($rootScope.params);
            }
        }, true);

        $rootScope.revealIfSticking = function (sticking, element) {
            if ($window.wow) {
                $window.wow.sync();
                if (sticking) {
                    $timeout(function () {
                        var targets = element.find('.wow').get();
                        for (var i = 0; i < targets.length; i++) {
                            $window.wow.show(targets[i]);
                        }
                    })
                }
            }
        }
    }

    config.$inject = ['$locationProvider', '$stateProvider', '$transitionsProvider'];
    function config($locationProvider, $stateProvider, $transitionsProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
            rewriteLinks: false
        });
    }

    function modalSetController() {

    }
})();

